import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function QuickContactsDialerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"quick_contacts_dialer"}/>
}
